import React from 'react';
import { OrgChart } from '../components/OrgChart';
import { Mail, Phone, Building } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { SEO } from '../components/SEO';
export function TataKelolaPage() {
  return <>
      <SEO title="Tata Kelola Perusahaan - PT Wahana Konstruksi Mandiri | Corporate Governance" description="Struktur organisasi, manajemen, dan tata kelola perusahaan PT WKM. Komitmen pada transparansi, akuntabilitas, dan good corporate governance." keywords="tata kelola perusahaan, corporate governance, struktur organisasi, manajemen WKM, corporate secretary, direksi komisaris" data-id="element-567" />

      <div className="py-12 bg-wkm-slate-50 min-h-screen" data-id="element-568">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-569">
          <div className="text-center mb-12" data-id="element-570">
            <div className="inline-block px-3 py-1 bg-wkm-gold-100 text-wkm-gold-700 rounded-full text-xs font-semibold uppercase tracking-wide mb-4" data-id="element-571">
              Corporate Governance
            </div>
            <h1 className="text-4xl font-bold text-wkm-navy-900 mb-4" data-id="element-572">
              Tata Kelola Perusahaan
            </h1>
            <p className="text-lg text-wkm-slate-600 max-w-2xl mx-auto" data-id="element-573">
              Komitmen kami pada transparansi, akuntabilitas, dan tata kelola
              perusahaan yang baik.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12" data-id="element-574">
            <Card className="hover:border-wkm-gold-300 hover:shadow-lg transition-all duration-300" data-id="element-575">
              <div className="flex items-start mb-4" data-id="element-576">
                <div className="w-12 h-12 bg-wkm-gold-100 text-wkm-gold-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-577">
                  <Building className="w-6 h-6" data-id="element-578" />
                </div>
                <div data-id="element-579">
                  <h3 className="text-lg font-bold text-wkm-navy-900 mb-2" data-id="element-580">
                    Corporate Secretary
                  </h3>
                  <p className="text-sm text-wkm-slate-500" data-id="element-581">
                    Sekretaris Perusahaan
                  </p>
                </div>
              </div>
              <div className="space-y-3" data-id="element-582">
                <div className="flex items-center text-sm" data-id="element-583">
                  <Mail className="w-4 h-4 text-wkm-gold-500 mr-3 flex-shrink-0" data-id="element-584" />
                  <a href="mailto:corsec@wkmkonstruksi.id" className="text-wkm-slate-600 hover:text-wkm-gold-600 transition-colors" data-id="element-585">
                    corsec@wkmkonstruksi.id
                  </a>
                </div>
                <p className="text-sm text-wkm-slate-600 mt-4" data-id="element-586">
                  Mengelola komunikasi dengan stakeholder, regulator, dan
                  publik. Memastikan kepatuhan terhadap regulasi dan keterbukaan
                  informasi.
                </p>
              </div>
            </Card>

            <Card className="hover:border-wkm-gold-300 hover:shadow-lg transition-all duration-300" data-id="element-587">
              <div className="flex items-start mb-4" data-id="element-588">
                <div className="w-12 h-12 bg-wkm-gold-100 text-wkm-gold-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-589">
                  <Building className="w-6 h-6" data-id="element-590" />
                </div>
                <div data-id="element-591">
                  <h3 className="text-lg font-bold text-wkm-navy-900 mb-2" data-id="element-592">
                    Direksi
                  </h3>
                  <p className="text-sm text-wkm-slate-500" data-id="element-593">
                    Board of Directors
                  </p>
                </div>
              </div>
              <p className="text-sm text-wkm-slate-600" data-id="element-594">
                Bertanggung jawab atas pengelolaan operasional perusahaan
                sehari-hari dan implementasi strategi bisnis.
              </p>
            </Card>

            <Card className="hover:border-wkm-gold-300 hover:shadow-lg transition-all duration-300" data-id="element-595">
              <div className="flex items-start mb-4" data-id="element-596">
                <div className="w-12 h-12 bg-wkm-gold-100 text-wkm-gold-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-597">
                  <Building className="w-6 h-6" data-id="element-598" />
                </div>
                <div data-id="element-599">
                  <h3 className="text-lg font-bold text-wkm-navy-900 mb-2" data-id="element-600">
                    Dewan Komisaris
                  </h3>
                  <p className="text-sm text-wkm-slate-500" data-id="element-601">
                    Board of Commissioners
                  </p>
                </div>
              </div>
              <p className="text-sm text-wkm-slate-600" data-id="element-602">
                Melakukan pengawasan terhadap kebijakan pengurusan, jalannya
                pengurusan, dan memberikan nasihat kepada Direksi.
              </p>
            </Card>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 border border-wkm-slate-200 mb-12" data-id="element-603">
            <h2 className="text-2xl font-bold text-wkm-navy-900 mb-6" data-id="element-604">
              Struktur Organisasi
            </h2>
            <OrgChart data-id="element-605" />
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-wkm-slate-200" data-id="element-606">
            <h2 className="text-2xl font-bold text-wkm-navy-900 mb-6" data-id="element-607">
              Prinsip Tata Kelola
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-608">
              <div data-id="element-609">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-610">
                  Transparansi
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-611">
                  Keterbukaan informasi material dan relevan kepada stakeholder
                  secara tepat waktu, memadai, jelas, akurat, dan dapat
                  diperbandingkan.
                </p>
              </div>
              <div data-id="element-612">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-613">
                  Akuntabilitas
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-614">
                  Kejelasan fungsi, pelaksanaan, dan pertanggungjawaban organ
                  perusahaan sehingga pengelolaan berjalan efektif.
                </p>
              </div>
              <div data-id="element-615">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-616">
                  Responsibilitas
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-617">
                  Kesesuaian pengelolaan perusahaan dengan peraturan
                  perundang-undangan dan prinsip korporasi yang sehat.
                </p>
              </div>
              <div data-id="element-618">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-619">
                  Independensi
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-620">
                  Pengelolaan perusahaan secara profesional tanpa benturan
                  kepentingan dan pengaruh/tekanan dari pihak manapun.
                </p>
              </div>
              <div data-id="element-621">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-622">
                  Kewajaran
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-623">
                  Keadilan dan kesetaraan dalam memenuhi hak-hak stakeholder
                  yang timbul berdasarkan perjanjian dan peraturan.
                </p>
              </div>
              <div data-id="element-624">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-625">
                  Integritas
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-626">
                  Komitmen pada nilai-nilai etika dan profesionalisme dalam
                  setiap aspek pengelolaan perusahaan.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}